<template>
    <div class="lm-zoom-control" :class="[mapLayout]" v-if="$root.env !== 'renderer'">
        <div class="lm-zoom-control-inner">
            <button :class="[{'disabled':disabled}]" @click.prevent="incrementZoom">+</button>
            <div class="lm-zoom-control-inner-spacer"></div>
            <button :class="[{'disabled':disabled}]" @click.prevent="decrementZoom">-</button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'TxZoomControl',
        props: {
            value: {},
            disabled: {},
            mapLayout: {}
        },

        methods:{
            decrementZoom() {
                if (this.disabled) return;
                if (this.value > 1) {
                    this.$emit('input',this.value - 1);
                }
            },
            incrementZoom() {
                if (this.disabled) return;
                if (this.value < 19) {
                    this.$emit('input',this.value + 1);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .lm-zoom-control {
        position: absolute;
        z-index: 10;
        @media (max-width: 599px) {
            &.horizontal,
            &.vertical {
                bottom: 10px;
                left: 10px;
            }
        }
        @media (min-width: 600px) {
            &.vertical {
                top: 20px;
                left: 20px;
            }
            &.horizontal {
                top: 15px;
                left: 20px;
            }
        }

        &-inner {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            justify-content: center;
            align-content: stretch;
            align-items: stretch;

            @media (max-width: 599px) {
                flex-direction: row;
            }

            padding: 1px;
            background: rgba(255, 255, 255, 0.8);

            &-spacer {

            }

            button {
                @media (max-width: 599px) {
                    padding: 5px 15px;
                    &:first-child {
                        margin-right: 1px;
                    }
                }
                @media (min-width: 600px) {
                    &:first-child {
                        margin-bottom: 1px;
                    }
                }

                order: 0;
                flex: 0 1 auto;
                align-self: auto;

                -webkit-appearance: button;
                text-transform: none;
                font-family: inherit; /* 1 */
                line-height: 1.15; /* 1 */
                margin: 0; /* 2 */

                font-size: 22px !important;
                padding: 10px 20px;
                font-weight: bold;

                background: #EC7A5C;

                &.disabled {
                    /*background: #ccc;*/
                    cursor: default;

                    &:hover {
                        opacity: 1;
                    }
                }

                opacity: 1;
                transition: opacity 0.3s;
                -webkit-transition: opacity 0.3s;

                cursor: pointer;

                &:hover {
                    opacity: 0.6;
                }
            }
        }

    }
</style>
